import * as api from "./rest_client.js";
import * as t from "./extractions.types.generated";

export interface IExtractions {

    /** Confirm notify about changes */
    confirmNotifyAboutChanges(req: t.IConfirmNotifyAboutChangesReq): Promise<t.IConfirmNotifyAboutChangesRes>;


    /** Set notify about changes for a user */
    setAdminNotifyAboutChangesForUser(req: t.ISetAdminNotifyAboutChangesForUserReq): Promise<t.ISetAdminNotifyAboutChangesForUserRes>;


    /** Retrieve audit-log for specific entity */
    getAdminAuditLogForEntity(req: t.IGetAdminAuditLogForEntityReq): Promise<t.IGetAdminAuditLogForEntityRes>;


    /** Get job details */
    getJobDetails(req: t.IGetJobDetailsReq): Promise<t.IGetJobDetailsRes>;


    /** Get context */
    getContextAdmin(req: t.IGetContextAdminReq): Promise<t.IGetContextAdminRes>;


    /** Update context */
    updateContextAdmin(req: t.IUpdateContextAdminReq): Promise<t.IUpdateContextAdminRes>;


    /** Delete existing context */
    deleteContextAdmin(req: t.IDeleteContextAdminReq): Promise<t.IDeleteContextAdminRes>;


    /** Restore existing context */
    restoreContextAdmin(req: t.IRestoreContextAdminReq): Promise<t.IRestoreContextAdminRes>;


    /** Export template */
    exportTemplate(req: t.IExportTemplateReq): Promise<t.IExportTemplateRes>;


    /** Get template */
    getTemplate(req: t.IGetTemplateReq): Promise<t.IGetTemplateRes>;


    /** Get template */
    getTemplateAdmin(req: t.IGetTemplateAdminReq): Promise<t.IGetTemplateAdminRes>;


    /** Update existing template */
    updateTemplate(req: t.IUpdateTemplateReq): Promise<t.IUpdateTemplateRes>;


    /** Delete existing template */
    deleteTemplate(req: t.IDeleteTemplateReq): Promise<t.IDeleteTemplateRes>;


    /** Delete existing template */
    deleteTemplateAdmin(req: t.IDeleteTemplateAdminReq): Promise<t.IDeleteTemplateAdminRes>;


    /** Restore existing template */
    restoreTemplateAdmin(req: t.IRestoreTemplateAdminReq): Promise<t.IRestoreTemplateAdminRes>;


    /** List all templates */
    listTemplates(req: t.IListTemplatesReq): Promise<t.IListTemplatesRes>;


    /** Create new template */
    createTemplate(req: t.ICreateTemplateReq): Promise<t.ICreateTemplateRes>;


    /** Import a template */
    importTemplate(req: t.IImportTemplateReq): Promise<t.IImportTemplateRes>;


    /** Clone a template */
    cloneTemplate(req: t.ICloneTemplateReq): Promise<t.ICloneTemplateRes>;


    /** Evaluate template on given data */
    evaluateTemplate(req: t.IEvaluateTemplateReq): Promise<t.IEvaluateTemplateRes>;


    /** Get evaluation results for a template */
    getEvaluationResults(req: t.IGetEvaluationResultsReq): Promise<t.IGetEvaluationResultsRes>;


    /** Get example for a template */
    getTemplateExample(req: t.IGetTemplateExampleReq): Promise<t.IGetTemplateExampleRes>;


    /** Get examples for a template */
    getTemplateExamples(req: t.IGetTemplateExamplesReq): Promise<t.IGetTemplateExamplesRes>;


    /** List of attachments for provided example item uuids */
    listExamplesAttachments(req: t.IListExamplesAttachmentsReq): Promise<t.IListExamplesAttachmentsRes>;


    /** Create new example for a template from an item */
    createExampleFromItem(req: t.ICreateExampleFromItemReq): Promise<t.ICreateExampleFromItemRes>;


    /** Update example for a template */
    updateExample(req: t.IUpdateExampleReq): Promise<t.IUpdateExampleRes>;


    /** Delete example for a template */
    deleteExample(req: t.IDeleteExampleReq): Promise<t.IDeleteExampleRes>;


    /** Get all possible example tags for a template */
    getExampleTagsForTemplate(req: t.IGetExampleTagsForTemplateReq): Promise<t.IGetExampleTagsForTemplateRes>;


    /** Check if example has all required tags for a given onboarding step */
    hasExampleTagsForOnboardingStep(req: t.IHasExampleTagsForOnboardingStepReq): Promise<t.IHasExampleTagsForOnboardingStepRes>;


    /** Get stats for a template */
    getEvalStatsForTemplate(req: t.IGetEvalStatsForTemplateReq): Promise<t.IGetEvalStatsForTemplateRes>;


    /** Get possible extract endpoints for a template */
    getExtractEndpointsForTemplate(req: t.IGetExtractEndpointsForTemplateReq): Promise<t.IGetExtractEndpointsForTemplateRes>;


    /** Create onboarding for a template */
    createTemplateOnboarding(req: t.ICreateTemplateOnboardingReq): Promise<t.ICreateTemplateOnboardingRes>;


    /** Get onboarding for a template */
    getTemplateOnboarding(req: t.IGetTemplateOnboardingReq): Promise<t.IGetTemplateOnboardingRes>;


    /** Set onboarding step for a template */
    setTemplateOnboardingStep(req: t.ISetTemplateOnboardingStepReq): Promise<t.ISetTemplateOnboardingStepRes>;


    /** Update onboarding for a template */
    updateTemplateOnboarding(req: t.IUpdateTemplateOnboardingReq): Promise<t.IUpdateTemplateOnboardingRes>;


    /** Create new endpoint */
    createEndpoint(req: t.ICreateEndpointReq): Promise<t.ICreateEndpointRes>;


    /** Update existing endpoint */
    updateEndpoint(req: t.IUpdateEndpointReq): Promise<t.IUpdateEndpointRes>;


    /** Delete existing endpoint */
    deleteEndpoint(req: t.IDeleteEndpointReq): Promise<t.IDeleteEndpointRes>;


    /** Delete existing endpoint */
    deleteEndpointAdmin(req: t.IDeleteEndpointAdminReq): Promise<t.IDeleteEndpointAdminRes>;


    /** Restore existing endpoint */
    restoreEndpointAdmin(req: t.IRestoreEndpointAdminReq): Promise<t.IRestoreEndpointAdminRes>;


    /** List all endpoints */
    listEndpoints(req: t.IListEndpointsReq): Promise<t.IListEndpointsRes>;


    /** Get endpoint */
    getEndpoint(req: t.IGetEndpointReq): Promise<t.IGetEndpointRes>;


    /** Get endpoint */
    getEndpointAdmin(req: t.IGetEndpointAdminReq): Promise<t.IGetEndpointAdminRes>;


    /** Update IP whitelist for an endpoint */
    updateEndpointIPWhitelist(req: t.IUpdateEndpointIPWhitelistReq): Promise<t.IUpdateEndpointIPWhitelistRes>;


    /** Create new connector */
    createConnector(req: t.ICreateConnectorReq): Promise<t.ICreateConnectorRes>;


    /** List all connectors */
    listConnectors(req: t.IListConnectorsReq): Promise<t.IListConnectorsRes>;


    /** Get connector */
    getConnector(req: t.IGetConnectorReq): Promise<t.IGetConnectorRes>;


    /** Delete existing connector */
    deleteConnector(req: t.IDeleteConnectorReq): Promise<t.IDeleteConnectorRes>;


    /** Update existing connector */
    updateConnector(req: t.IUpdateConnectorReq): Promise<t.IUpdateConnectorRes>;


    /** Get Microsoft Graph API stats */
    getMicrosoftGraphApiStats(req: t.IGetMicrosoftGraphApiStatsReq): Promise<t.IGetMicrosoftGraphApiStatsRes>;


    /** Test Microsoft Graph API connector */
    testMicrosoftGraphApiConnector(req: t.ITestMicrosoftGraphApiConnectorReq): Promise<t.ITestMicrosoftGraphApiConnectorRes>;


    /** Send test email for Microsoft Graph API connector */
    sendTestEmailForMicrosoftGraphApiConnector(req: t.ISendTestEmailForMicrosoftGraphApiConnectorReq): Promise<t.ISendTestEmailForMicrosoftGraphApiConnectorRes>;


    /** List all API keys */
    listAPIKeys(req: t.IListAPIKeysReq): Promise<t.IListAPIKeysRes>;


    /** Create new API key */
    createAPIKey(req: t.ICreateAPIKeyReq): Promise<t.ICreateAPIKeyRes>;


    /** Get API key */
    getAPIKey(req: t.IGetAPIKeyReq): Promise<t.IGetAPIKeyRes>;


    /** Delete API key */
    deleteAPIKey(req: t.IDeleteAPIKeyReq): Promise<t.IDeleteAPIKeyRes>;


    /** Get all user templates */
    getAdminUserTemplates(req: t.IGetAdminUserTemplatesReq): Promise<t.IGetAdminUserTemplatesRes>;


    /** Get user template */
    getAdminUserTemplate(req: t.IGetAdminUserTemplateReq): Promise<t.IGetAdminUserTemplateRes>;


    /** Log template definition download */
    logAdminTemplateDefDownload(req: t.ILogAdminTemplateDefDownloadReq): Promise<t.ILogAdminTemplateDefDownloadRes>;


    /** Execute a debug function call */
    adminExecuteDebugFunctionCall(req: t.IAdminExecuteDebugFunctionCallReq): Promise<t.IAdminExecuteDebugFunctionCallRes>;


    /** Get debug function calls for a job */
    getAdminDebugJobFunctionCalls(req: t.IGetAdminDebugJobFunctionCallsReq): Promise<t.IGetAdminDebugJobFunctionCallsRes>;


    /** Resend webhook data for given job */
    resendWebhookData(req: t.IResendWebhookDataReq): Promise<t.IResendWebhookDataRes>;


    /** Cancel a job */
    cancelJob(req: t.ICancelJobReq): Promise<t.ICancelJobRes>;


    /** Get webhook log */
    getWebhookLog(req: t.IGetWebhookLogReq): Promise<t.IGetWebhookLogRes>;


    /** Get list of open extract confirmations */
    getOpenExtractConfirmations(req: t.IGetOpenExtractConfirmationsReq): Promise<t.IGetOpenExtractConfirmationsRes>;


    /** Update the scrape of an extract confirmation */
    updateExtractConfirmationScrape(req: t.IUpdateExtractConfirmationScrapeReq): Promise<t.IUpdateExtractConfirmationScrapeRes>;


    /** Update the status of an item of an extract confirmation */
    updateExtractConfirmationItemStatus(req: t.IUpdateExtractConfirmationItemStatusReq): Promise<t.IUpdateExtractConfirmationItemStatusRes>;


    /** List all items */
    listItems(req: t.IListItemsReq): Promise<t.IListItemsRes>;


    /** Remove items */
    deleteItems(req: t.IDeleteItemsReq): Promise<t.IDeleteItemsRes>;


    /** Get an item */
    getItem(req: t.IGetItemReq): Promise<t.IGetItemRes>;


    /** Verify an item */
    verifyItem(req: t.IVerifyItemReq): Promise<t.IVerifyItemRes>;


    /** Executes the code that transforms val_raw to val for all records for all scrapes of item */
    executeItemPostprocessing(req: t.IExecuteItemPostprocessingReq): Promise<t.IExecuteItemPostprocessingRes>;


    /** Reprocesses the records of an item */
    reprocessItemRecords(req: t.IReprocessItemRecordsReq): Promise<t.IReprocessItemRecordsRes>;


    /** Create a new lookup table */
    createLookupTable(req: t.ICreateLookupTableReq): Promise<t.ICreateLookupTableRes>;


    /** Update a lookup table */
    updateLookupTable(req: t.IUpdateLookupTableReq): Promise<t.IUpdateLookupTableRes>;


    /** Delete a lookup table */
    deleteLookupTable(req: t.IDeleteLookupTableReq): Promise<t.IDeleteLookupTableRes>;


    /** Get all lookup tables */
    getLookupTables(req: t.IGetLookupTablesReq): Promise<t.IGetLookupTablesRes>;


    /** Get a lookup table */
    getLookupTable(req: t.IGetLookupTableReq): Promise<t.IGetLookupTableRes>;


    /** Upload a new version of a lookup table */
    uploadLookupTableVersion(req: t.IUploadLookupTableVersionReq): Promise<t.IUploadLookupTableVersionRes>;


    /** List all rows of a lookup table */
    listLookupTableRows(req: t.IListLookupTableRowsReq): Promise<t.IListLookupTableRowsRes>;


    /** List aggregated rows of a lookup table */
    listLookupTableRowsAggregated(req: t.IListLookupTableRowsAggregatedReq): Promise<t.IListLookupTableRowsAggregatedRes>;


    /** Add a new row to a lookup table */
    addLookupTableRow(req: t.IAddLookupTableRowReq): Promise<t.IAddLookupTableRowRes>;


    /** Update a row of a lookup table */
    updateLookupTableRow(req: t.IUpdateLookupTableRowReq): Promise<t.IUpdateLookupTableRowRes>;


    /** Delete a row of a lookup table */
    deleteLookupTableRow(req: t.IDeleteLookupTableRowReq): Promise<t.IDeleteLookupTableRowRes>;


    /** Get all endpoints that have actions that use the lookup table */
    getEndpointsWithActionsForLookupTable(req: t.IGetEndpointsWithActionsForLookupTableReq): Promise<t.IGetEndpointsWithActionsForLookupTableRes>;


    /** List all widgets */
    listWidgets(req: t.IListWidgetsReq): Promise<t.IListWidgetsRes>;


    /** Create a new widget */
    createWidget(req: t.ICreateWidgetReq): Promise<t.ICreateWidgetRes>;


    /** Get widget details */
    getWidget(req: t.IGetWidgetReq): Promise<t.IGetWidgetRes>;


    /** Update widget details */
    updateWidget(req: t.IUpdateWidgetReq): Promise<t.IUpdateWidgetRes>;


    /** Delete widget */
    deleteWidget(req: t.IDeleteWidgetReq): Promise<t.IDeleteWidgetRes>;


    /** Preview widget */
    previewWidget(req: t.IPreviewWidgetReq): Promise<t.IPreviewWidgetRes>;


    /** Get referrals given some filters */
    getAdminReferrals(req: t.IGetAdminReferralsReq): Promise<t.IGetAdminReferralsRes>;


    /** Create a new referral */
    createNewReferral(req: t.ICreateNewReferralReq): Promise<t.ICreateNewReferralRes>;


    /** Get jobs for email digest */
    getEmailDigestJobs(req: t.IGetEmailDigestJobsReq): Promise<t.IGetEmailDigestJobsRes>;


    /** Send an email digest */
    sendEmailDigest(req: t.ISendEmailDigestReq): Promise<t.ISendEmailDigestRes>;


    /** Get list of all models */
    getModels(req: t.IGetModelsReq): Promise<t.IGetModelsRes>;


    /** Update model overrides for an organization */
    updateAdminModelOverrides(req: t.IUpdateAdminModelOverridesReq): Promise<t.IUpdateAdminModelOverridesRes>;


    /** Get handlebars result */
    getHandlebarsResult(req: t.IGetHandlebarsResultReq): Promise<t.IGetHandlebarsResultRes>;


    /** Get custom javascript result */
    getCustomJavascriptResult(req: t.IGetCustomJavascriptResultReq): Promise<t.IGetCustomJavascriptResultRes>;


    /** Get examples for given endpoint */
    getEndpointTestExamples(req: t.IGetEndpointTestExamplesReq): Promise<t.IGetEndpointTestExamplesRes>;


    /** Validate JS code */
    validateJsCode(req: t.IValidateJsCodeReq): Promise<t.IValidateJsCodeRes>;


    /** Execute chat completion */
    executeAdminChatCompletion(req: t.IExecuteAdminChatCompletionReq): Promise<t.IExecuteAdminChatCompletionRes>;


    /** Returns wizard template */
    getWizardTemplate(req: t.IGetWizardTemplateReq): Promise<t.IGetWizardTemplateRes>;


    /** Get list of all metabase dashboards */
    getAdminMetabaseDashboards(req: t.IGetAdminMetabaseDashboardsReq): Promise<t.IGetAdminMetabaseDashboardsRes>;


    /** Get a metabase dashboard by uuid */
    getAdminMetabaseDashboard(req: t.IGetAdminMetabaseDashboardReq): Promise<t.IGetAdminMetabaseDashboardRes>;


    /** Create a new metabase dashboard */
    createAdminMetabaseDashboard(req: t.ICreateAdminMetabaseDashboardReq): Promise<t.ICreateAdminMetabaseDashboardRes>;


    /** Delete a metabase dashboard */
    deleteAdminMetabaseDashboard(req: t.IDeleteAdminMetabaseDashboardReq): Promise<t.IDeleteAdminMetabaseDashboardRes>;


    /** Get last sync time of all metabase dashboards */
    getAdminLastSyncTime(req: t.IGetAdminLastSyncTimeReq): Promise<t.IGetAdminLastSyncTimeRes>;


    /** Add an element to the pinboard */
    addElementToPinboard(req: t.IAddElementToPinboardReq): Promise<t.IAddElementToPinboardRes>;


    /** Remove an element from the pinboard */
    removeElementFromPinboard(req: t.IRemoveElementFromPinboardReq): Promise<t.IRemoveElementFromPinboardRes>;


    /** List all elements in the pinboard */
    listPinboardElements(req: t.IListPinboardElementsReq): Promise<t.IListPinboardElementsRes>;


    /** Get options for a user */
    getAdminPinboardOptionsForUser(req: t.IGetAdminPinboardOptionsForUserReq): Promise<t.IGetAdminPinboardOptionsForUserRes>;


    /** List all elements in the pinboard for a user */
    listAdminPinboardElementsForUser(req: t.IListAdminPinboardElementsForUserReq): Promise<t.IListAdminPinboardElementsForUserRes>;


    /** Get options for a org */
    getAdminPinboardOptionsForOrg(req: t.IGetAdminPinboardOptionsForOrgReq): Promise<t.IGetAdminPinboardOptionsForOrgRes>;


    /** List all elements in the pinboard for an organization */
    listAdminPinboardElementsForOrg(req: t.IListAdminPinboardElementsForOrgReq): Promise<t.IListAdminPinboardElementsForOrgRes>;


    /** Admin add element to pinboard for user or org */
    adminAddElementToPinboard(req: t.IAdminAddElementToPinboardReq): Promise<t.IAdminAddElementToPinboardRes>;


    /** Admin remove element from pinboard for user or org */
    adminRemoveElementFromPinboard(req: t.IAdminRemoveElementFromPinboardReq): Promise<t.IAdminRemoveElementFromPinboardRes>;


    /** Start an email check */
    extractEmailStart(req: t.IExtractEmailStartReq): Promise<t.IExtractEmailStartRes>;


    /** Get email items by email external id */
    getEmailItemsByExternalId(req: t.IGetEmailItemsByExternalIdReq): Promise<t.IGetEmailItemsByExternalIdRes>;

}


function enc(s: any): string { return encodeURIComponent("" + s); }

export class Extractions implements IExtractions {

    client: api.IApiClient;

    constructor(client: api.IApiClient) { this.client = client; }

    /** Confirm notify about changes */
    async confirmNotifyAboutChanges(req: t.IConfirmNotifyAboutChangesReq): Promise<t.IConfirmNotifyAboutChangesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/user/confirm_notify_about_changes`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Set notify about changes for a user */
    async setAdminNotifyAboutChangesForUser(req: t.ISetAdminNotifyAboutChangesForUserReq): Promise<t.ISetAdminNotifyAboutChangesForUserRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/user/set_notify_about_changes`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Retrieve audit-log for specific entity */
    async getAdminAuditLogForEntity(req: t.IGetAdminAuditLogForEntityReq): Promise<t.IGetAdminAuditLogForEntityRes> {
        const reqx: any = req;
        const url = `/api/v1.0/audit-log/entries`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get job details */
    async getJobDetails(req: t.IGetJobDetailsReq): Promise<t.IGetJobDetailsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/jobs/get/${enc(req.job_uuid)}`;
        delete reqx.job_uuid;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Get context */
    async getContextAdmin(req: t.IGetContextAdminReq): Promise<t.IGetContextAdminRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/context/get/${enc(req.context_uuid)}`;
        delete reqx.context_uuid;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Update context */
    async updateContextAdmin(req: t.IUpdateContextAdminReq): Promise<t.IUpdateContextAdminRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/context/update`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Delete existing context */
    async deleteContextAdmin(req: t.IDeleteContextAdminReq): Promise<t.IDeleteContextAdminRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/context/delete/${enc(req.context_uuid)}`;
        delete reqx.context_uuid;
        const res = await this.client.delete(url, { params: reqx });
        return res.data;
    }


    /** Restore existing context */
    async restoreContextAdmin(req: t.IRestoreContextAdminReq): Promise<t.IRestoreContextAdminRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/context/restore/${enc(req.context_uuid)}`;
        delete reqx.context_uuid;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Export template */
    async exportTemplate(req: t.IExportTemplateReq): Promise<t.IExportTemplateRes> {
        const reqx: any = req;
        const url = `/api/v1.0/template/export/${enc(req.template_uuid)}`;
        delete reqx.template_uuid;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get template */
    async getTemplate(req: t.IGetTemplateReq): Promise<t.IGetTemplateRes> {
        const reqx: any = req;
        const url = `/api/v1.0/template/get/${enc(req.template_uuid)}`;
        delete reqx.template_uuid;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Get template */
    async getTemplateAdmin(req: t.IGetTemplateAdminReq): Promise<t.IGetTemplateAdminRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/template/get/${enc(req.template_uuid)}`;
        delete reqx.template_uuid;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Update existing template */
    async updateTemplate(req: t.IUpdateTemplateReq): Promise<t.IUpdateTemplateRes> {
        const reqx: any = req;
        const url = `/api/v1.0/template/put/${enc(req.template_uuid)}`;
        delete reqx.template_uuid;
        const res = await this.client.put(url, reqx);
        return res.data;
    }


    /** Delete existing template */
    async deleteTemplate(req: t.IDeleteTemplateReq): Promise<t.IDeleteTemplateRes> {
        const reqx: any = req;
        const url = `/api/v1.0/template/delete/${enc(req.template_uuid)}`;
        delete reqx.template_uuid;
        const res = await this.client.delete(url, { params: reqx });
        return res.data;
    }


    /** Delete existing template */
    async deleteTemplateAdmin(req: t.IDeleteTemplateAdminReq): Promise<t.IDeleteTemplateAdminRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/template/delete/${enc(req.template_uuid)}`;
        delete reqx.template_uuid;
        const res = await this.client.delete(url, { params: reqx });
        return res.data;
    }


    /** Restore existing template */
    async restoreTemplateAdmin(req: t.IRestoreTemplateAdminReq): Promise<t.IRestoreTemplateAdminRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/template/restore/${enc(req.template_uuid)}`;
        delete reqx.template_uuid;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** List all templates */
    async listTemplates(req: t.IListTemplatesReq): Promise<t.IListTemplatesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/templates/list`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Create new template */
    async createTemplate(req: t.ICreateTemplateReq): Promise<t.ICreateTemplateRes> {
        const reqx: any = req;
        const url = `/api/v1.0/templates/create`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Import a template */
    async importTemplate(req: t.IImportTemplateReq): Promise<t.IImportTemplateRes> {
        const reqx: any = req;
        const url = `/api/v1.0/templates/import`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Clone a template */
    async cloneTemplate(req: t.ICloneTemplateReq): Promise<t.ICloneTemplateRes> {
        const reqx: any = req;
        const url = `/api/v1.0/templates/clone`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Evaluate template on given data */
    async evaluateTemplate(req: t.IEvaluateTemplateReq): Promise<t.IEvaluateTemplateRes> {
        const reqx: any = req;
        const url = `/api/v1.0/templates/evaluate`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get evaluation results for a template */
    async getEvaluationResults(req: t.IGetEvaluationResultsReq): Promise<t.IGetEvaluationResultsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/templates/get_evaluation_results`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Get example for a template */
    async getTemplateExample(req: t.IGetTemplateExampleReq): Promise<t.IGetTemplateExampleRes> {
        const reqx: any = req;
        const url = `/api/v1.0/templates/example/${enc(req.item_uuid)}`;
        delete reqx.item_uuid;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Get examples for a template */
    async getTemplateExamples(req: t.IGetTemplateExamplesReq): Promise<t.IGetTemplateExamplesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/templates/examples`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** List of attachments for provided example item uuids */
    async listExamplesAttachments(req: t.IListExamplesAttachmentsReq): Promise<t.IListExamplesAttachmentsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/templates/examples/attachments`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Create new example for a template from an item */
    async createExampleFromItem(req: t.ICreateExampleFromItemReq): Promise<t.ICreateExampleFromItemRes> {
        const reqx: any = req;
        const url = `/api/v1.0/templates/example/create_from_item`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Update example for a template */
    async updateExample(req: t.IUpdateExampleReq): Promise<t.IUpdateExampleRes> {
        const reqx: any = req;
        const url = `/api/v1.0/templates/example/update`;
        const res = await this.client.put(url, reqx);
        return res.data;
    }


    /** Delete example for a template */
    async deleteExample(req: t.IDeleteExampleReq): Promise<t.IDeleteExampleRes> {
        const reqx: any = req;
        const url = `/api/v1.0/templates/example/delete/${enc(req.item_uuid)}`;
        delete reqx.item_uuid;
        const res = await this.client.delete(url, { params: reqx });
        return res.data;
    }


    /** Get all possible example tags for a template */
    async getExampleTagsForTemplate(req: t.IGetExampleTagsForTemplateReq): Promise<t.IGetExampleTagsForTemplateRes> {
        const reqx: any = req;
        const url = `/api/v1.0/template/example_tags/${enc(req.template_uuid)}`;
        delete reqx.template_uuid;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Check if example has all required tags for a given onboarding step */
    async hasExampleTagsForOnboardingStep(req: t.IHasExampleTagsForOnboardingStepReq): Promise<t.IHasExampleTagsForOnboardingStepRes> {
        const reqx: any = req;
        const url = `/api/v1.0/template/example_tags/has_tags/${enc(req.item_uuid)}`;
        delete reqx.item_uuid;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Get stats for a template */
    async getEvalStatsForTemplate(req: t.IGetEvalStatsForTemplateReq): Promise<t.IGetEvalStatsForTemplateRes> {
        const reqx: any = req;
        const url = `/api/v1.0/template/eval_stats/${enc(req.template_uuid)}`;
        delete reqx.template_uuid;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Get possible extract endpoints for a template */
    async getExtractEndpointsForTemplate(req: t.IGetExtractEndpointsForTemplateReq): Promise<t.IGetExtractEndpointsForTemplateRes> {
        const reqx: any = req;
        const url = `/api/v1.0/template/${enc(req.template_uuid)}/extract-endpoints`;
        delete reqx.template_uuid;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Create onboarding for a template */
    async createTemplateOnboarding(req: t.ICreateTemplateOnboardingReq): Promise<t.ICreateTemplateOnboardingRes> {
        const reqx: any = req;
        const url = `/api/v1.0/template/onboarding/${enc(req.template_uuid)}/create`;
        delete reqx.template_uuid;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get onboarding for a template */
    async getTemplateOnboarding(req: t.IGetTemplateOnboardingReq): Promise<t.IGetTemplateOnboardingRes> {
        const reqx: any = req;
        const url = `/api/v1.0/template/onboarding/${enc(req.template_uuid)}/get`;
        delete reqx.template_uuid;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Set onboarding step for a template */
    async setTemplateOnboardingStep(req: t.ISetTemplateOnboardingStepReq): Promise<t.ISetTemplateOnboardingStepRes> {
        const reqx: any = req;
        const url = `/api/v1.0/template/onboarding/${enc(req.template_uuid)}/set_step`;
        delete reqx.template_uuid;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Update onboarding for a template */
    async updateTemplateOnboarding(req: t.IUpdateTemplateOnboardingReq): Promise<t.IUpdateTemplateOnboardingRes> {
        const reqx: any = req;
        const url = `/api/v1.0/template/onboarding/${enc(req.template_uuid)}/update`;
        delete reqx.template_uuid;
        const res = await this.client.put(url, reqx);
        return res.data;
    }


    /** Create new endpoint */
    async createEndpoint(req: t.ICreateEndpointReq): Promise<t.ICreateEndpointRes> {
        const reqx: any = req;
        const url = `/api/v1.0/endpoints/create`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Update existing endpoint */
    async updateEndpoint(req: t.IUpdateEndpointReq): Promise<t.IUpdateEndpointRes> {
        const reqx: any = req;
        const url = `/api/v1.0/endpoints/update`;
        const res = await this.client.put(url, reqx);
        return res.data;
    }


    /** Delete existing endpoint */
    async deleteEndpoint(req: t.IDeleteEndpointReq): Promise<t.IDeleteEndpointRes> {
        const reqx: any = req;
        const url = `/api/v1.0/endpoints/delete/${enc(req.endpoint_uuid)}`;
        delete reqx.endpoint_uuid;
        const res = await this.client.delete(url, { params: reqx });
        return res.data;
    }


    /** Delete existing endpoint */
    async deleteEndpointAdmin(req: t.IDeleteEndpointAdminReq): Promise<t.IDeleteEndpointAdminRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/endpoints/delete/${enc(req.endpoint_uuid)}`;
        delete reqx.endpoint_uuid;
        const res = await this.client.delete(url, { params: reqx });
        return res.data;
    }


    /** Restore existing endpoint */
    async restoreEndpointAdmin(req: t.IRestoreEndpointAdminReq): Promise<t.IRestoreEndpointAdminRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/endpoints/restore/${enc(req.endpoint_uuid)}`;
        delete reqx.endpoint_uuid;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** List all endpoints */
    async listEndpoints(req: t.IListEndpointsReq): Promise<t.IListEndpointsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/endpoints/list`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Get endpoint */
    async getEndpoint(req: t.IGetEndpointReq): Promise<t.IGetEndpointRes> {
        const reqx: any = req;
        const url = `/api/v1.0/endpoint/${enc(req.endpoint_uuid)}`;
        delete reqx.endpoint_uuid;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Get endpoint */
    async getEndpointAdmin(req: t.IGetEndpointAdminReq): Promise<t.IGetEndpointAdminRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/endpoint/${enc(req.endpoint_uuid)}`;
        delete reqx.endpoint_uuid;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Update IP whitelist for an endpoint */
    async updateEndpointIPWhitelist(req: t.IUpdateEndpointIPWhitelistReq): Promise<t.IUpdateEndpointIPWhitelistRes> {
        const reqx: any = req;
        const url = `/api/v1.0/endpoints/update_ip_whitelist`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Create new connector */
    async createConnector(req: t.ICreateConnectorReq): Promise<t.ICreateConnectorRes> {
        const reqx: any = req;
        const url = `/api/v1.0/connectors/create`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** List all connectors */
    async listConnectors(req: t.IListConnectorsReq): Promise<t.IListConnectorsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/connectors/list`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Get connector */
    async getConnector(req: t.IGetConnectorReq): Promise<t.IGetConnectorRes> {
        const reqx: any = req;
        const url = `/api/v1.0/connector/${enc(req.connector_uuid)}`;
        delete reqx.connector_uuid;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Delete existing connector */
    async deleteConnector(req: t.IDeleteConnectorReq): Promise<t.IDeleteConnectorRes> {
        const reqx: any = req;
        const url = `/api/v1.0/connector/${enc(req.connector_uuid)}`;
        delete reqx.connector_uuid;
        const res = await this.client.delete(url, { params: reqx });
        return res.data;
    }


    /** Update existing connector */
    async updateConnector(req: t.IUpdateConnectorReq): Promise<t.IUpdateConnectorRes> {
        const reqx: any = req;
        const url = `/api/v1.0/connector/${enc(req.connector_uuid)}`;
        delete reqx.connector_uuid;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get Microsoft Graph API stats */
    async getMicrosoftGraphApiStats(req: t.IGetMicrosoftGraphApiStatsReq): Promise<t.IGetMicrosoftGraphApiStatsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/connector/microsoft_graph_api/stats`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Test Microsoft Graph API connector */
    async testMicrosoftGraphApiConnector(req: t.ITestMicrosoftGraphApiConnectorReq): Promise<t.ITestMicrosoftGraphApiConnectorRes> {
        const reqx: any = req;
        const url = `/api/v1.0/connector/microsoft_graph_api/test`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Send test email for Microsoft Graph API connector */
    async sendTestEmailForMicrosoftGraphApiConnector(req: t.ISendTestEmailForMicrosoftGraphApiConnectorReq): Promise<t.ISendTestEmailForMicrosoftGraphApiConnectorRes> {
        const reqx: any = req;
        const url = `/api/v1.0/connector/microsoft_graph_api/send_test_email`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** List all API keys */
    async listAPIKeys(req: t.IListAPIKeysReq): Promise<t.IListAPIKeysRes> {
        const reqx: any = req;
        const url = `/api/v1.0/apikeys/list`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Create new API key */
    async createAPIKey(req: t.ICreateAPIKeyReq): Promise<t.ICreateAPIKeyRes> {
        const reqx: any = req;
        const url = `/api/v1.0/api-keys/create`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get API key */
    async getAPIKey(req: t.IGetAPIKeyReq): Promise<t.IGetAPIKeyRes> {
        const reqx: any = req;
        const url = `/api/v1.0/api-key/${enc(req.key_uuid)}`;
        delete reqx.key_uuid;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Delete API key */
    async deleteAPIKey(req: t.IDeleteAPIKeyReq): Promise<t.IDeleteAPIKeyRes> {
        const reqx: any = req;
        const url = `/api/v1.0/api-key/${enc(req.key_uuid)}`;
        delete reqx.key_uuid;
        const res = await this.client.delete(url, { params: reqx });
        return res.data;
    }


    /** Get all user templates */
    async getAdminUserTemplates(req: t.IGetAdminUserTemplatesReq): Promise<t.IGetAdminUserTemplatesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/user_templates`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Get user template */
    async getAdminUserTemplate(req: t.IGetAdminUserTemplateReq): Promise<t.IGetAdminUserTemplateRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/user_template`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Log template definition download */
    async logAdminTemplateDefDownload(req: t.ILogAdminTemplateDefDownloadReq): Promise<t.ILogAdminTemplateDefDownloadRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/log_template_def_download`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Execute a debug function call */
    async adminExecuteDebugFunctionCall(req: t.IAdminExecuteDebugFunctionCallReq): Promise<t.IAdminExecuteDebugFunctionCallRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/execute_debug_function_call`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get debug function calls for a job */
    async getAdminDebugJobFunctionCalls(req: t.IGetAdminDebugJobFunctionCallsReq): Promise<t.IGetAdminDebugJobFunctionCallsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/job/${enc(req.job_uuid)}/debug_function_calls`;
        delete reqx.job_uuid;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Resend webhook data for given job */
    async resendWebhookData(req: t.IResendWebhookDataReq): Promise<t.IResendWebhookDataRes> {
        const reqx: any = req;
        const url = `/api/v1.0/job/${enc(req.job_uuid)}/resend-webhook`;
        delete reqx.job_uuid;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Cancel a job */
    async cancelJob(req: t.ICancelJobReq): Promise<t.ICancelJobRes> {
        const reqx: any = req;
        const url = `/api/v1.0/job/${enc(req.id)}/cancel`;
        delete reqx.id;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get webhook log */
    async getWebhookLog(req: t.IGetWebhookLogReq): Promise<t.IGetWebhookLogRes> {
        const reqx: any = req;
        const url = `/api/v1.0/webhook/${enc(req.webhook_connector_uuid)}/log`;
        delete reqx.webhook_connector_uuid;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Get list of open extract confirmations */
    async getOpenExtractConfirmations(req: t.IGetOpenExtractConfirmationsReq): Promise<t.IGetOpenExtractConfirmationsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/extract_confirmation/open`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Update the scrape of an extract confirmation */
    async updateExtractConfirmationScrape(req: t.IUpdateExtractConfirmationScrapeReq): Promise<t.IUpdateExtractConfirmationScrapeRes> {
        const reqx: any = req;
        const url = `/api/v1.0/extract_confirmation/update_scrape`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Update the status of an item of an extract confirmation */
    async updateExtractConfirmationItemStatus(req: t.IUpdateExtractConfirmationItemStatusReq): Promise<t.IUpdateExtractConfirmationItemStatusRes> {
        const reqx: any = req;
        const url = `/api/v1.0/extract_confirmation/update_item_status`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** List all items */
    async listItems(req: t.IListItemsReq): Promise<t.IListItemsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/items/list`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Remove items */
    async deleteItems(req: t.IDeleteItemsReq): Promise<t.IDeleteItemsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/items/delete`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get an item */
    async getItem(req: t.IGetItemReq): Promise<t.IGetItemRes> {
        const reqx: any = req;
        const url = `/api/v1.0/item/get`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Verify an item */
    async verifyItem(req: t.IVerifyItemReq): Promise<t.IVerifyItemRes> {
        const reqx: any = req;
        const url = `/api/v1.0/item/verify`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Executes the code that transforms val_raw to val for all records for all scrapes of item */
    async executeItemPostprocessing(req: t.IExecuteItemPostprocessingReq): Promise<t.IExecuteItemPostprocessingRes> {
        const reqx: any = req;
        const url = `/api/v1.0/item/execute_item_postprocessing`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Reprocesses the records of an item */
    async reprocessItemRecords(req: t.IReprocessItemRecordsReq): Promise<t.IReprocessItemRecordsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/item/reprocess_records`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Create a new lookup table */
    async createLookupTable(req: t.ICreateLookupTableReq): Promise<t.ICreateLookupTableRes> {
        const reqx: any = req;
        const url = `/api/v1.0/lookup_table/create`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Update a lookup table */
    async updateLookupTable(req: t.IUpdateLookupTableReq): Promise<t.IUpdateLookupTableRes> {
        const reqx: any = req;
        const url = `/api/v1.0/lookup_table/update`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Delete a lookup table */
    async deleteLookupTable(req: t.IDeleteLookupTableReq): Promise<t.IDeleteLookupTableRes> {
        const reqx: any = req;
        const url = `/api/v1.0/lookup_table/delete`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get all lookup tables */
    async getLookupTables(req: t.IGetLookupTablesReq): Promise<t.IGetLookupTablesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/lookup_tables/get`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Get a lookup table */
    async getLookupTable(req: t.IGetLookupTableReq): Promise<t.IGetLookupTableRes> {
        const reqx: any = req;
        const url = `/api/v1.0/lookup_table/get`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Upload a new version of a lookup table */
    async uploadLookupTableVersion(req: t.IUploadLookupTableVersionReq): Promise<t.IUploadLookupTableVersionRes> {
        const reqx: any = req;
        const url = `/api/v1.0/lookup_table/upload_version`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** List all rows of a lookup table */
    async listLookupTableRows(req: t.IListLookupTableRowsReq): Promise<t.IListLookupTableRowsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/lookup_table/rows/list`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** List aggregated rows of a lookup table */
    async listLookupTableRowsAggregated(req: t.IListLookupTableRowsAggregatedReq): Promise<t.IListLookupTableRowsAggregatedRes> {
        const reqx: any = req;
        const url = `/api/v1.0/lookup_table/rows/aggregated/list`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Add a new row to a lookup table */
    async addLookupTableRow(req: t.IAddLookupTableRowReq): Promise<t.IAddLookupTableRowRes> {
        const reqx: any = req;
        const url = `/api/v1.0/lookup_table/row/add`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Update a row of a lookup table */
    async updateLookupTableRow(req: t.IUpdateLookupTableRowReq): Promise<t.IUpdateLookupTableRowRes> {
        const reqx: any = req;
        const url = `/api/v1.0/lookup_table/row/update`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Delete a row of a lookup table */
    async deleteLookupTableRow(req: t.IDeleteLookupTableRowReq): Promise<t.IDeleteLookupTableRowRes> {
        const reqx: any = req;
        const url = `/api/v1.0/lookup_table/row/delete`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get all endpoints that have actions that use the lookup table */
    async getEndpointsWithActionsForLookupTable(req: t.IGetEndpointsWithActionsForLookupTableReq): Promise<t.IGetEndpointsWithActionsForLookupTableRes> {
        const reqx: any = req;
        const url = `/api/v1.0/lookup_table/endpoints_with_actions`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** List all widgets */
    async listWidgets(req: t.IListWidgetsReq): Promise<t.IListWidgetsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/widgets/list`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Create a new widget */
    async createWidget(req: t.ICreateWidgetReq): Promise<t.ICreateWidgetRes> {
        const reqx: any = req;
        const url = `/api/v1.0/widget/create`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get widget details */
    async getWidget(req: t.IGetWidgetReq): Promise<t.IGetWidgetRes> {
        const reqx: any = req;
        const url = `/api/v1.0/widget/${enc(req.widget_uuid)}`;
        delete reqx.widget_uuid;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Update widget details */
    async updateWidget(req: t.IUpdateWidgetReq): Promise<t.IUpdateWidgetRes> {
        const reqx: any = req;
        const url = `/api/v1.0/widget/${enc(req.widget_uuid)}`;
        delete reqx.widget_uuid;
        const res = await this.client.put(url, reqx);
        return res.data;
    }


    /** Delete widget */
    async deleteWidget(req: t.IDeleteWidgetReq): Promise<t.IDeleteWidgetRes> {
        const reqx: any = req;
        const url = `/api/v1.0/widget/${enc(req.widget_uuid)}`;
        delete reqx.widget_uuid;
        const res = await this.client.delete(url, { params: reqx });
        return res.data;
    }


    /** Preview widget */
    async previewWidget(req: t.IPreviewWidgetReq): Promise<t.IPreviewWidgetRes> {
        const reqx: any = req;
        const url = `/api/v1.0/widget/${enc(req.widget_uuid)}/preview`;
        delete reqx.widget_uuid;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get referrals given some filters */
    async getAdminReferrals(req: t.IGetAdminReferralsReq): Promise<t.IGetAdminReferralsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/referral`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Create a new referral */
    async createNewReferral(req: t.ICreateNewReferralReq): Promise<t.ICreateNewReferralRes> {
        const reqx: any = req;
        const url = `/api/v1.0/referral`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get jobs for email digest */
    async getEmailDigestJobs(req: t.IGetEmailDigestJobsReq): Promise<t.IGetEmailDigestJobsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/email_digest/${enc(req.connector_uuid)}`;
        delete reqx.connector_uuid;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Send an email digest */
    async sendEmailDigest(req: t.ISendEmailDigestReq): Promise<t.ISendEmailDigestRes> {
        const reqx: any = req;
        const url = `/api/v1.0/email_digest/send`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get list of all models */
    async getModels(req: t.IGetModelsReq): Promise<t.IGetModelsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/models`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Update model overrides for an organization */
    async updateAdminModelOverrides(req: t.IUpdateAdminModelOverridesReq): Promise<t.IUpdateAdminModelOverridesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/org/models_overrides`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get handlebars result */
    async getHandlebarsResult(req: t.IGetHandlebarsResultReq): Promise<t.IGetHandlebarsResultRes> {
        const reqx: any = req;
        const url = `/api/v1.0/handlebars/render`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get custom javascript result */
    async getCustomJavascriptResult(req: t.IGetCustomJavascriptResultReq): Promise<t.IGetCustomJavascriptResultRes> {
        const reqx: any = req;
        const url = `/api/v1.0/custom_javascript/render`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get examples for given endpoint */
    async getEndpointTestExamples(req: t.IGetEndpointTestExamplesReq): Promise<t.IGetEndpointTestExamplesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/endpoint_test/examples`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Validate JS code */
    async validateJsCode(req: t.IValidateJsCodeReq): Promise<t.IValidateJsCodeRes> {
        const reqx: any = req;
        const url = `/api/v1.0/js_validate`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Execute chat completion */
    async executeAdminChatCompletion(req: t.IExecuteAdminChatCompletionReq): Promise<t.IExecuteAdminChatCompletionRes> {
        const reqx: any = req;
        const url = `/api/v1.0/chat_completion`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Returns wizard template */
    async getWizardTemplate(req: t.IGetWizardTemplateReq): Promise<t.IGetWizardTemplateRes> {
        const reqx: any = req;
        const url = `/api/v1.0/wizard_template`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get list of all metabase dashboards */
    async getAdminMetabaseDashboards(req: t.IGetAdminMetabaseDashboardsReq): Promise<t.IGetAdminMetabaseDashboardsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/dw_dashboards/list`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Get a metabase dashboard by uuid */
    async getAdminMetabaseDashboard(req: t.IGetAdminMetabaseDashboardReq): Promise<t.IGetAdminMetabaseDashboardRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/dw_dashboards/get/${enc(req.dashboard_uuid)}`;
        delete reqx.dashboard_uuid;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Create a new metabase dashboard */
    async createAdminMetabaseDashboard(req: t.ICreateAdminMetabaseDashboardReq): Promise<t.ICreateAdminMetabaseDashboardRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/dw_dashboard/create`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Delete a metabase dashboard */
    async deleteAdminMetabaseDashboard(req: t.IDeleteAdminMetabaseDashboardReq): Promise<t.IDeleteAdminMetabaseDashboardRes> {
        const reqx: any = req;
        const url = `/api/v1.0/dw_dashboard/delete/${enc(req.dashboard_uuid)}`;
        delete reqx.dashboard_uuid;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get last sync time of all metabase dashboards */
    async getAdminLastSyncTime(req: t.IGetAdminLastSyncTimeReq): Promise<t.IGetAdminLastSyncTimeRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/dw_dashboards/last_sync`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Add an element to the pinboard */
    async addElementToPinboard(req: t.IAddElementToPinboardReq): Promise<t.IAddElementToPinboardRes> {
        const reqx: any = req;
        const url = `/api/v1.0/pinboard/add`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Remove an element from the pinboard */
    async removeElementFromPinboard(req: t.IRemoveElementFromPinboardReq): Promise<t.IRemoveElementFromPinboardRes> {
        const reqx: any = req;
        const url = `/api/v1.0/pinboard/remove`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** List all elements in the pinboard */
    async listPinboardElements(req: t.IListPinboardElementsReq): Promise<t.IListPinboardElementsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/pinboard/list`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get options for a user */
    async getAdminPinboardOptionsForUser(req: t.IGetAdminPinboardOptionsForUserReq): Promise<t.IGetAdminPinboardOptionsForUserRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/pinboard/options_user`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** List all elements in the pinboard for a user */
    async listAdminPinboardElementsForUser(req: t.IListAdminPinboardElementsForUserReq): Promise<t.IListAdminPinboardElementsForUserRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/pinboard/list_user`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Get options for a org */
    async getAdminPinboardOptionsForOrg(req: t.IGetAdminPinboardOptionsForOrgReq): Promise<t.IGetAdminPinboardOptionsForOrgRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/pinboard/options_org`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** List all elements in the pinboard for an organization */
    async listAdminPinboardElementsForOrg(req: t.IListAdminPinboardElementsForOrgReq): Promise<t.IListAdminPinboardElementsForOrgRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/pinboard/list_org`;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }


    /** Admin add element to pinboard for user or org */
    async adminAddElementToPinboard(req: t.IAdminAddElementToPinboardReq): Promise<t.IAdminAddElementToPinboardRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/pinboard/add`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Admin remove element from pinboard for user or org */
    async adminRemoveElementFromPinboard(req: t.IAdminRemoveElementFromPinboardReq): Promise<t.IAdminRemoveElementFromPinboardRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/pinboard/remove`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Start an email check */
    async extractEmailStart(req: t.IExtractEmailStartReq): Promise<t.IExtractEmailStartRes> {
        const reqx: any = req;
        const url = `/api/v1.0/email/check_start`;
        const res = await this.client.post(url, reqx);
        return res.data;
    }


    /** Get email items by email external id */
    async getEmailItemsByExternalId(req: t.IGetEmailItemsByExternalIdReq): Promise<t.IGetEmailItemsByExternalIdRes> {
        const reqx: any = req;
        const url = `/api/v1.0/email/items/${enc(req.external_type)}/${enc(req.external_id)}`;
        delete reqx.external_type;
        delete reqx.external_id;
        const res = await this.client.get(url, { params: reqx });
        return res.data;
    }

}
